import React, { useState } from "react";
import axios from "axios";
import { useApp } from "../context/AppContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Official Google "G" logo as inline SVG
const GoogleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className="w-5 h-5">
    <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" />
    <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z" />
    <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" />
    <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571.001-.001.002-.001.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" />
  </svg>
);

/**
 * Direct Google OAuth — uses our own credentials, no Emergent intermediary.
 * Flow: backend gives us the Google authorize URL → user goes to Google →
 * Google redirects to /auth/google/callback with `code` → AuthCallback POSTs
 * the code to /api/auth/google/exchange → backend returns BScan JWT.
 */
export const GoogleSignInButton = ({ className = "" }) => {
  const { language } = useApp();
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const redirectUri = window.location.origin + "/auth/google/callback";
      const res = await axios.get(`${API}/auth/google/login-url`, {
        params: { redirect_uri: redirectUri },
      });
      // Persist state for CSRF check on return
      try { sessionStorage.setItem("bscan_google_oauth_state", res.data.state); } catch (e) { void e; }
      window.location.href = res.data.url;
    } catch (e) {
      void e;
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      className={`w-full flex items-center justify-center gap-3 px-4 py-3 rounded-md border border-white/15 bg-white/5 hover:bg-white/10 text-white text-sm font-medium transition-colors disabled:opacity-60 ${className}`}
      data-testid="google-signin-btn"
    >
      <GoogleIcon />
      <span>
        {loading
          ? (language === "es" ? "Conectando..." : "Connecting...")
          : (language === "es" ? "Continuar con Google" : "Continue with Google")}
      </span>
    </button>
  );
};

